import { SBContact } from "@smart/bridge-smokeball-basic";
import { Button, RadioButtons } from "@smart/itops-sb-design-system-dom";
import { buildDisplayName } from "@smart/itops-utils-basic";

import { ContactDetails } from "./contact-details";

export const ContactItem = ({
  contact,
  isChecked,
  value,
  onChange,
  label,
  description,
  openContact,
  compareToContact,
  disabled,
}: {
  contact: Omit<SBContact, "id"> & { id?: string };
  compareToContact?: Omit<SBContact, "id"> & { id?: string };
  isChecked: boolean;
  value: string;
  onChange: (value: string) => void;
  label: string;
  description?: string;
  openContact: ((id: string) => void) | undefined;
  disabled?: boolean;
}) => {
  const contactName =
    (contact.person && Object.keys(contact.person).length
      ? buildDisplayName(contact.person, contact.id || "")
      : contact.company?.name || contact.trust?.name || contact.id) ||
    "Intake contact";

  const compareToContactName =
    (compareToContact?.person && Object.keys(compareToContact?.person).length
      ? buildDisplayName(compareToContact?.person, compareToContact?.id || "")
      : compareToContact?.company?.name ||
        compareToContact?.trust?.name ||
        compareToContact?.id) || "Intake contact";

  return (
    <div data-testid="contact-item" className="flex flex-col gap-[0.6rem]">
      <div className="font-semibold flex items-center gap-small py-[0.4rem] h-[3.2rem]">
        <RadioButtons
          dataTestId={`${label}-radio-button`}
          onChange={onChange}
          options={[{ value, label }]}
          value={isChecked ? value : ""}
          disabled={disabled}
        />
        {contact.id && openContact && (
          <Button
            variant="highlight"
            size="small"
            rightIcon="solidUpRightFromSquare"
            onClick={() => openContact(contact.id!)}
            dataTestId="open-contact"
          />
        )}
      </div>
      {description && (
        <>
          <div className="text-caption text-neutral-600 pl-[2.6rem] mb-[0.4rem] flex items-start h-[3.2rem]">
            {description}
          </div>
          <div className="border-b border-gray-300 mb-[0.4rem]" />
        </>
      )}
      <div className="flex flex-col gap-medium pl-[2.6rem] flex-1">
        <div className="flex gap-small items-center">
          <div className="font-semibold">{contactName}</div>
          {contactName !== compareToContactName && (
            <div className="h-[0.8rem] w-[0.8rem] rounded-full bg-yellow-450" />
          )}
        </div>
        <ContactDetails contact={contact} compareToContact={compareToContact} />
      </div>
    </div>
  );
};
